const initialState = {
    isOpen: false,
    isActive: false,
    mobile: '', 
    mobileErr: '',
};
const modalEditMobile = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_EDIT_MOBILE':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalEditMobile;
